import React from 'react';
import PropTypes from 'prop-types';

const DoneBlueLogo = ({ size, flat }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {flat ? (
      <rect width="80" height="80" rx="28" fill="white" fillOpacity="0.4" />
    ) : (
      <rect
        width="80"
        height="80"
        fill="none"
      />
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.3338 40C73.3338 58.4095 58.4099 73.3334 40.0004 73.3334C21.5909 73.3334 6.66699 58.4095 6.66699 40C6.66699 21.5905 21.5909 6.66669 40.0004 6.66669C58.4099 6.66669 73.3338 21.5905 73.3338 40Z"
      fill="url(#paint0_linear_2026_51973)"
    />
    <path
      d="M54.0156 30.7598L34.9274 49.9578C34.8492 50.0365 34.722 50.0365 34.6438 49.9578L26.9331 42.2028"
      stroke="white"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2026_51973"
        x1="52.4779"
        y1="57.0411"
        x2="12.5143"
        y2="10.0249"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3F58EA" />
        <stop offset="0.510417" stopColor="#0075FF" />
        <stop offset="1" stopColor="#24A5FF" />
      </linearGradient>
    </defs>
  </svg>
);

DoneBlueLogo.propTypes = {
  flat: PropTypes.bool, // White semi transparent background instead of a gradient background
  size: PropTypes.number,
};

DoneBlueLogo.defaultProps = {
  flat: false,
  size: 80,
};

export default DoneBlueLogo;
